/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Map View Icon component.
 */
export const MapViewIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M15.9451 5.85622C15.8352 5.88879 15.7174 5.88262 15.6115 5.83874L9.05517 3.12147C8.94939 3.07763 8.83177 3.07143 8.72196 3.10389L2.35823 4.98554C2.14578 5.04836 2 5.24348 2 5.46502V20.5164C2 20.8505 2.32138 21.0906 2.64177 20.9959L8.72174 19.1981C8.83168 19.1656 8.94946 19.1719 9.05533 19.2159L15.5952 21.9327C15.7011 21.9767 15.8189 21.983 15.9288 21.9505L22.2924 20.0689C22.5048 20.0061 22.6506 19.811 22.6506 19.5894V4.5385C22.6506 4.20427 22.329 3.96414 22.0085 4.05911L15.9451 5.85622Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M8.94873 3V19.0901' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M15.7305 5.70996V21.8001' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
    </svg>
  );
};

export default MapViewIcon;
